export const WARN_UNDEFINED_TASK_UNIT_TYPE = 'undefined task unit type, must be U or P, means users or positions';


// WEBPACK FOOTER //
// ./src/common/api/constants.js